import { render, staticRenderFns } from "./wf-text-area-edit.vue?vue&type=template&id=235eff24&scoped=true&"
import script from "./wf-text-area-edit.vue?vue&type=script&lang=ts&"
export * from "./wf-text-area-edit.vue?vue&type=script&lang=ts&"
import style0 from "./wf-text-area-edit.vue?vue&type=style&index=0&id=235eff24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235eff24",
  null
  
)

export default component.exports